import React, {Component} from 'react';
import CustomForm from "../../../shared/components/form/CustomForm";
import {CallTrackingFieldConfig} from "../../../shared/components/form/FormFieldsConfig";

class CallTrackingFieldCard extends Component {
  constructor(props) {
    super(props);

    this.state = {}
  }

  render() {
    return (
      <CustomForm
        config={CallTrackingFieldConfig}
        onSubmit={(form) => this.props.onSave(form)}
        isLoading={this.props.isLoading}
        initialValues={this.props.initialValues}
      />
    )
  }

}

export default CallTrackingFieldCard;
